module.exports = __webpack_public_path__ + "img/IMG_9701_L_Wood_MockedUp.dedd0be1.jpg";